import React from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useLocationContext } from "context/LocationContext";
import TrackerRegistrationWorkspace from "./components/TrackerRegistrationWorkspace";

const TrackerRegistration = ({ embedded = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { currentLocation } = useLocationContext();

  const trackerId = location?.state?.trackerId || searchParams.get("tracker") || "";
  const trackerLabelFromState = location?.state?.trackerLabel || "";
  const returnTo = location?.state?.returnTo || "/ghana/trackers";
  const currentOrgUnitId = location?.state?.orgUnitId || currentLocation?.orgUnitId || "";

  return (
    <div className={embedded ? "bg-background" : "min-h-screen bg-background"}>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <TrackerRegistrationWorkspace
            trackerId={trackerId}
            trackerLabel={trackerLabelFromState}
            currentOrgUnitId={currentOrgUnitId}
            onCancel={() => navigate(returnTo)}
          />
        </div>
      </div>
    </div>
  );
};

export default TrackerRegistration;
